var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOpenEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5851 9.79875C15.623 9.917 15.7063 10.0154 15.8166 10.0723C15.927 10.1293 16.0554 10.1401 16.1738 10.1025C16.4176 10.0238 16.5563 9.76125 16.4776 9.51375L16.4772 9.51263C16.4438 9.4125 14.5654 3.75 8.99968 3.75C3.43505 3.75 1.5563 9.4125 1.5233 9.513L1.52293 9.51375C1.44418 9.76125 1.57918 10.0238 1.82668 10.1025C2.07418 10.1813 2.33668 10.0462 2.41543 9.79875C2.48293 9.58875 4.10668 4.6875 9.00043 4.6875C13.8942 4.6875 15.5176 9.58875 15.5851 9.79875ZM9.00005 13.5C9.89516 13.5 10.7536 13.1444 11.3865 12.5115C12.0195 11.8785 12.3751 11.0201 12.3751 10.125C12.3751 9.22989 12.0195 8.37145 11.3865 7.73851C10.7536 7.10558 9.89516 6.75 9.00005 6.75C8.10495 6.75 7.2465 7.10558 6.61357 7.73851C5.98063 8.37145 5.62505 9.22989 5.62505 10.125C5.62505 11.0201 5.98063 11.8785 6.61357 12.5115C7.2465 13.1444 8.10495 13.5 9.00005 13.5Z",
    fill: "#8F8F8F"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenEye);
export default __webpack_public_path__ + "static/media/open_eye.0d60685689d433c67c9bb68e62e30622.svg";
export { ForwardRef as ReactComponent };